<template>
    <footer>
        <div class="footer-text">
            <div class="notice">
                <div>
                    <div class="highlight">社團法人台灣有點溫暖毛孩協會</div>
                    <div>協會立案字號：台內團字第1090074606號</div>
                    <div>勸募許可文號：衛部救字第1131362292號</div>
                </div>
                <div>
                    <div class="highlight">如有需要救援、中途安置、弱勢園區請聯繫我們</div>
                    <div>E-mail：warmdog2021@gmail.com</div>
                    <div>LINE@：@warm.tw</div>
                </div>
                <div>
                    <div class="f-logo">
                        <img src="@/assets/footer.svg" alt="" />
                    </div>
                    <div class="socials">
                        <a href="https://www.instagram.com/warm.2021" target="_blank"><img src="@/assets/ig.svg" alt="" /></a>
                        <a href="https://www.facebook.com/warm.2021" target="_blank"><img src="@/assets/fb.svg" alt="" /></a>
                        <a href="https://lin.ee/zbqYaz6" target="_blank"><img src="@/assets/line.svg" alt="" /></a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup></script>

<style scoped>
footer {
    height: 96px;
    background-color: #bfb1a8;
    display: flex;
    align-items: center;
    justify-content: center; /* 如需水平居中也可以添加此屬性 */
}

.footer-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: left;
    color: #fff;
    line-height: 18px;
    font-size: 13px;
}

.notice {
    display: flex;
    gap: 40px;
}

.f-logo {
    margin-bottom: 0.625em;
}

.socials {
    display: flex;
    justify-content: center;
    gap: 14px;
}

.notice .highlight {
    font-size: 16px;
    font-weight: 600;
}
</style>
